// Render percentage change badge based on current vs previous value
export const getPercentChange = (current, previous) => {
  if (
    current === undefined ||
    previous === undefined ||
    previous === 0 ||
    (current === 0 && previous === 0)
  )
    return (
      <span
        style={{
          marginLeft: 8,
          fontSize: "0.9rem",
          fontWeight: 600,
          color: "#008000",
        }}
      >
        {current >= 0 ? "↑" : "↓"} N/A
      </span>
    );
  const change = ((current - previous) / Math.abs(previous)) * 100;
  const isPositive = change >= 0;
  const color = isPositive ? "#008000" : "#ff4d4f";
  const arrow = isPositive ? "↑" : "↓";
  return (
    <span style={{ marginLeft: 8, color, fontSize: "0.9rem", fontWeight: 600 }}>
      {arrow} {Math.abs(change).toFixed(0)}%
    </span>
  );
};
